import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchRoles, fetchToken, loginUser, sessionTimeout } from '../../store/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import InitialDialog from '../../components/InitialDialog/InitialDialog';
import { Panel } from '@appkit4/react-components/panel';
import { Link } from 'react-router-dom';
const Home: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const idToken = useSelector((state: RootState) => state.auth.idToken)
  const roles = useSelector((state: RootState) => state.auth.roles)
  const isLoading = useSelector((state: RootState) => state.auth.loading)
  const accessToken = useSelector((state: RootState) => state.auth.accessToken)
  const [username, setUsername] = useState('')

  useEffect(() => {

    const authenticateUser = async () => {
      try {

        await dispatch(fetchToken()).unwrap();
        await dispatch(fetchRoles()).unwrap();
      }
      catch (error) {
        if (error === 'No accounts found') {
          await dispatch(loginUser())
        }
        else {
          dispatch(sessionTimeout(true))
        }
      }
    }
    if (!idToken || !roles.length) {
      authenticateUser()
    }

  }, [dispatch, navigate, roles, idToken])

  useEffect(() => {
    if (accessToken) {
      const arrayToken = accessToken.split('.');
      const tokenPayload = JSON.parse(atob(arrayToken[1]));
      setUsername(tokenPayload?.given_name)
    }
  }, [accessToken])
  const handleEmailClick = (e: any) => {
    e.preventDefault();
    const email = 'support@yourcompany.com';
    const subject = 'Support Request';
    const emailBody = '';
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;
    window.open(mailtoLink, '_blank');
  };
  if (isLoading) {
    return (<div className="page-not-input">
      <h1 className="color">Loading..</h1>
      <span className="text-spacing">Please wait while we set up your access</span>
    </div>)
  }
  else if (roles.includes('No roles available')) {
    return (<div className="page-not-input">
      <h1 className="color">Access restricted</h1>
      <span className="text-spacing">It appears that your account does not have the necessary permissions to use this app. Please contact us for assistance.</span>
    </div>)
  }
  else if (!isLoading && roles.length > 0) {
    return (
      <>
        <InitialDialog />
        <div className="page-not-input">
          <h2 style={{ fontSize: 'x-large', marginBottom: '10px' }} className="color">Welcome {username}!</h2>
          <p style={{ fontSize: 'large', marginBottom: '10px' }}>Please select a module from the sidebar to get started.</p>
          <br></br>
          <div className="ap-simple-panel-container">
            <Panel title="" >
              <p style={{ paddingTop: '10px' }}>
                Instructions, guidance for use and frequently asked questions can be found
                <Link className="color" to="/help"> here</Link>.
              </p>
              <p className="text-spacing">
                If you do not have access to any modules please
                <a className="color" href="#" onClick={handleEmailClick}> contact the support team</a>.
              </p>
            </Panel>
          </div>
        </div>
      </>
    );
  }
  else {
    return (
      <div className="page-not-input">
        <h1 className="color">Sorry!</h1>
        <span className="text-spacing">Session timed out. Please login again to continue.</span>
      </div>)
  }
};

export default Home;
